// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__8UlJu","col":"styles_col__1P66h"};